import type { IPendo } from '@lib/pendo-types';
import { IPendoWindow } from '@lib/pendo-types';
import { getRegion, isPublicTrackingHost } from 'mt-shared';

declare const window: IPendoWindow;
const apiKey = PENDO_KEY;

/* eslint-disable */
export function loadLib() {
  (function (p,e,n,d,o){let v,w,x,y,z;o=p[d]=p[d]||{};o._q=[];
    v=['initialize','identify','updateOptions','pageLoad'];for(w=0,x=v.length;w<x;++w)(function(m){
      o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
    y=e.createElement(n);y.async=!0;y.src='https://content.pendo.gomotive.com/agent/static/'+apiKey+'/pendo.js';
    z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');
}
/* eslint-enable */

/**
 * Returns the Pendo `APP_INITIALIZER` for the public module: the real loader
 * everywhere except the anonymous tracking (`tracking.`) and dispatch tracking
 * (`trace.`) hosts (mt-shared's `isPublicTrackingHost`), where Pendo has no
 * visitor to identify and every cookie it plants brings the S3-served page
 * closer to the 8 KB header limit.
 * See TSSD-32472, AG-9932.
 */
export function getPublicPendoInitializer(hostname: string = window.location.hostname): () => void {
  return isPublicTrackingHost(hostname) ? (): void => undefined : loadLib;
}

export function initPendo(
  // user attributes
  visitorId,
  visitorEmail,
  visitorRole,
  visitorCompanyRole,
  visitorCompanyConnectionRole,
  createdAt,
  firstName,
  lastName,
  cycle,
  visitorLanguage,
  isShopManageAllowed,
  // company attributes
  id,
  companyName,
  companyId,
  industry,
  freightCarried,
  companyCycle,
  enabledFeatures,
  numActiveElds,
  sfAccountStatus,
  state,
  subscriptionPlan,
  compositeFleetSize,
  eventIntelligenceEnabled,
  proTrialStartDate,
  proTrialEndDate,
  isEligibleForShop,
  ecommEligibility,
  companyCountry,
  appVersion,
) {
  loadLib();
  const pendo: IPendo = window.pendo;

  pendo.initialize({
    visitor: {
      id: visitorId,
      user_id: visitorId,
      email: visitorEmail,
      role: visitorRole,
      companyRole: visitorCompanyRole,
      companyConnectionRole: visitorCompanyConnectionRole,
      created_at: createdAt,
      first_name: firstName,
      last_name: lastName,
      cycle,
      app_version: appVersion,
      app_language: visitorLanguage,
      dashboard_release: CLIENT_APP_VERSION,
      is_shop_manage_allowed: isShopManageAllowed,
      region: getRegion(),
    },
    account: {
      id,
      account_id: id,
      name: companyName,
      company_id: companyId,
      industry,
      freight_carried: freightCarried ? freightCarried.toString() : '',
      company_cycle: companyCycle,
      enabled_features: enabledFeatures,
      num_active_elds: numActiveElds,
      sf_account_status: sfAccountStatus,
      state,
      subscription_plan: subscriptionPlan,
      fleetSize: compositeFleetSize,
      annotation_tag_enabled: eventIntelligenceEnabled,
      dashboard_upsell_pro_trial_start_date: proTrialStartDate,
      dashboard_upsell_pro_trial_end_date: proTrialEndDate,
      is_eligible_for_shop: isEligibleForShop,
      ecomm_eligibility: ecommEligibility,
      country: companyCountry,
    },
  });
}
